import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Default from './components/Default/Default';
import Review from './components/Review/Review';
import Submit from './components/Submit/Submit';
import Unqualified from './components/Unqualified/Unqualified';
import NoLoan from './components/NoLoan/NoLoan';
import NoShare from './components/NoShare/NoShare';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Default />} />
        <Route path="/Review" element={<Review />} />
        <Route path="/Submit" element={<Submit />} />
        <Route path="/Unqualified" element={<Unqualified />} />
        <Route path="/NoLoan" element={<NoLoan/>} />
        <Route path="/NoShare" element={<NoShare/>} />

      </Routes>
    </div>
  );
}

export default App;